import { t } from 'ember-intl';
import SpdsInputSearch from 'ember-simplepractice/components/spds/input/search';
import styles from './conversation-search.module.scss';

<template>
  <div class="{{styles.component}} conversation-search" data-test-conversation-search>
    <SpdsInputSearch
      @onClearInput={{@clearSearch}}
      @onInput={{@updateSearch}}
      @placeholder={{t "emc.conversation_list.search_placeholder"}}
      @value={{@search}}
      class="search-input"
      as |search|
    >
      <search.trigger />
    </SpdsInputSearch>
  </div>
</template>
